import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BcAlertComponent } from '@bancolombia/design-system-web/bc-alert';
import { BcDialogService } from "@bancolombia/design-system-web/bc-services";
import { v4 as uuidv4 } from "uuid";

import { FacturaGateway } from "../../models/factura/gateways/factura.gateway";
import { FacturaContentModel, FacturaModel } from "../../models/factura/factura.model";
import { HttpResponse } from "@angular/common/http";
import { FacturaCambioEstadoModel } from "../../models/factura/factura-cambio-estado.model";

@Injectable(
  {
      providedIn: 'root'
  }
)
export class FacturaUseCase {
  constructor(private gateway: FacturaGateway, private dialogService: BcDialogService) { }

  findAll(page?: number, size?: number, data?: string, option?: string, estado?: string): Observable<FacturaModel> {
    return this.gateway.findAll(page, size, data, option, estado);
  }

  findByNumero(data: string | null = ''): Observable<FacturaContentModel> {
    return this.gateway.findByNumero(data);
  }

  export(data?: string, option?: string): Observable<HttpResponse<Blob>> {
    return this.gateway.export(data, option);
  }

  descargarExport(data: HttpResponse<Blob>, name: string = 'Facturas'): void {
    const fileName = `${name}-${uuidv4()}.csv`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data.body!);
    link.download = fileName;
    link.click();
  }

  procesarCssTable(tipo: string): string {
    switch (tipo) {
      case 'NA':
        return 'btn-default';
      case 'P':
        return 'btn-preaprobado';
      case 'R':
        return 'btn-rechazado';
      default:
        return 'btn-aprobado';
    }
  }

  openAlert(type: string = 'success', title: string, message: string, timeout: number = 10000): void {
    const dialogRef = this.dialogService.open(BcAlertComponent, {
      id: 'MyAlertId',
      title: title,
      type: type,
      text: message,
      timeout: timeout,
    });

    dialogRef.onResult().subscribe(
      (closed) => { },
      (dismissed) => { },
      () => { }
    );
  }

  cambiarEstado(facturaCambioEstadoModel: FacturaCambioEstadoModel): Observable<FacturaContentModel> {
    return this.gateway.cambiarEstado(facturaCambioEstadoModel);
  }
}